import { AdContent } from "./ad-content.model";
import { OrderAdDetailUpdate } from "./order-ad-detail-update.model";
import { OrderServiceUpdate } from "./order-service-update";

export class CalculateRequest {
	id?: string;
	render?: boolean;
	orderAdDetailUpdates?: OrderAdDetailUpdate[];
	adContents?: AdContent[];
	orderServiceUpdates?: OrderServiceUpdate[];
	advertiserId?: string;
	otherPayerId?: string;
	subscriberNumber?: string;
}
